import React, {useState} from 'react';
import ToastContext from "../stores/toast/toastcontext";
import Toast from 'react-bootstrap/Toast';
import styles from "./allertoast.module.scss";

const toastStyleByStatus = {
    success: 'aller_toast_success',
    error: 'aller_toast_error',
    warning: 'aller_toast_warning',
}

const AllerToast = (props) => {

    const [show, setShow] = useState(false);
    const [message, setMessage] = useState('');
    const [status, setStatus] = useState('success');

    // statusOrFlag is either the legacy boolean isNotValid (true -> error, false/undefined ->
    // success) or one of 'success' | 'error' | 'warning'.
    const display = (desc, statusOrFlag) => {
        setMessage(desc);
        setShow(true);
        setStatus(statusOrFlag === 'warning' ? 'warning' : (statusOrFlag ? 'error' : 'success'));
    };

    return (
        <ToastContext.Provider value={{ display }}>
            <div className={`  ${styles[toastStyleByStatus[status]]} ${styles.aller_toast}`}>
                <Toast onClose={() => {setShow(false);setStatus('success');}} show={show} delay={5000} autohide>
                    <Toast.Body>{message}</Toast.Body>
                </Toast>
            </div>
            {props.children}
        </ToastContext.Provider>
    )
}

export default AllerToast;